import React from 'react';
import { renderIfPresent } from 'utils/renderIfPresent';
import type { newsfeedsSelector } from 'store/ducks/newsfeeds/selectors';
import type { Banner } from 'store/ducks/banners/types';
import { Subscription, ArticlePostVideo } from '../../../../components';
import MaterialsLink from '../materialsLink';
import PostVideoLink from '../postVideoLink';
import ArticlesPost from '../articlesPost';

type Props = {
  newsfeeds: Readonly<ReturnType<typeof newsfeedsSelector>>;
  position7Banner: Banner | null;
  position8Banner: Banner | null;
  position9Banner: Banner | null;
};

export default function AuthorPostsResults({
  newsfeeds,
  position7Banner,
  position8Banner,
  position9Banner,
}: Props) {
  if (!newsfeeds || !newsfeeds.length) return null;
  let indexPost = 0;
  const addIndex = (i: number) => {
    indexPost = i + 1;
  };
  return (
    <div className="page-newsfeed__body">
      {(newsfeeds[indexPost] && newsfeeds[indexPost]?.isVideo && (
        <div className="card card--l">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <ArticlePostVideo {...item} />
          ))}
          {addIndex(indexPost)}
        </div>
      )) || (
        <div className="card card--l">
          <article className="post-video others__post-video">
            {renderIfPresent(newsfeeds[indexPost], item => (
              <PostVideoLink {...item} isCategory={false} />
            ))}
            {addIndex(indexPost)}
          </article>
        </div>
      )}
      {newsfeeds[indexPost] && (
        <div className="card card--l">
          <article className="post-video others__post-video">
            {renderIfPresent(newsfeeds[indexPost], item => (
              <PostVideoLink {...item} isCategory={false} />
            ))}
            {addIndex(indexPost)}
          </article>
        </div>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {(newsfeeds.length > 3 && position7Banner && (
        <div className="card card--m">
          {(position7Banner.html && position7Banner.html !== '' && (
            <>{position7Banner.html}</>
          )) || (
            <a
              href={position7Banner.url}
              className="materials__link"
              target="_blank"
            >
              <div className="promo others__promo">
                <img className="promo__img" src={position7Banner.img} alt="#" />
              </div>
            </a>
          )}
        </div>
      )) || (
        <>
          {newsfeeds[indexPost] && (
            <article className="card card--m">
              {renderIfPresent(newsfeeds[indexPost], item => (
                <MaterialsLink {...item} />
              ))}
              {addIndex(indexPost)}
            </article>
          )}
        </>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {(newsfeeds[indexPost] || newsfeeds[indexPost + 1]) && (
        <div className="card card--xl">
          <div className="card__wrapper">
            {newsfeeds[indexPost] && (
              <article className="post post--articles articles__post">
                {renderIfPresent(newsfeeds[indexPost], item => (
                  <ArticlesPost {...item} />
                ))}
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="post post--articles post--articles-yellow articles__post">
                {renderIfPresent(newsfeeds[indexPost], item => (
                  <ArticlesPost {...item} />
                ))}
                {addIndex(indexPost)}
              </article>
            )}
          </div>
        </div>
      )}
      {(newsfeeds.length > 6 && position9Banner && (
        <div className="card card--xl-v">
          <div className="promo articles__promo">
            {(position9Banner.html && position9Banner.html !== '' && (
              <>{position9Banner.html}</>
            )) || (
              <a href={position9Banner.url} target="_blank">
                <img className="promo__img" src={position9Banner.img} alt="#" />
              </a>
            )}
            {/* <div className="tag tag--white tag--mobile">
                                        Реклама
                                    </div> */}
          </div>
        </div>
      )) ||
        (newsfeeds.length > 6 && (
          <div className="card card--xl-v">
            {renderIfPresent(newsfeeds[indexPost], item => (
              <MaterialsLink {...item} />
            ))}
            {addIndex(indexPost)}
          </div>
        ))}
      {newsfeeds[indexPost] && (
        <article className="post-video others__post-video card card--l">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <PostVideoLink isCategory={false} {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="post-video others__post-video card card--l">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <PostVideoLink isCategory={false} {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {(newsfeeds.length > 9 && position8Banner && (
        <div className="card card--m">
          {(position8Banner.html && position8Banner.html !== '' && (
            <>{position8Banner.html}</>
          )) || (
            <a href={position8Banner.url} className="materials__link">
              <div className="promo others__promo">
                <img className="promo__img" src={position8Banner.img} alt="#" />
              </div>
            </a>
          )}
        </div>
      )) ||
        (newsfeeds.length > 9 && (
          <div className="card card--m">
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                {renderIfPresent(newsfeeds[indexPost], item => (
                  <MaterialsLink {...item} />
                ))}
                {addIndex(indexPost)}
              </article>
            )}
          </div>
        ))}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      <div className="card card--xxl">
        <Subscription page="page-newsfeed" mod="" />
      </div>
      {newsfeeds[indexPost] && (
        <article className="post-video others__post-video card card--l">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <PostVideoLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="post-video others__post-video card card--l">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <PostVideoLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds[indexPost] && (
        <article className="card card--m">
          {renderIfPresent(newsfeeds[indexPost], item => (
            <MaterialsLink {...item} />
          ))}
          {addIndex(indexPost)}
        </article>
      )}
      {newsfeeds.slice(indexPost).map(item => (
        <article className="card card--m" key={item.id}>
          <MaterialsLink {...item} />
        </article>
      ))}
    </div>
  );
}
